import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { CategoryGrid } from '../components/CategoryGrid';
import { FeaturedListings } from '../components/FeaturedListings';
import { HowItWorks } from '../components/HowItWorks';
import { Footer } from '../components/Footer';
export function LocantoPage() {
  return <div className="min-h-screen bg-[#F5F5F5] font-sans text-gray-900" data-id="element-162">
      <Header data-id="element-163" />
      <main data-id="element-164">
        <HeroSection data-id="element-165" />
        <CategoryGrid data-id="element-166" />
        <FeaturedListings data-id="element-167" />
        <HowItWorks data-id="element-168" />
      </main>
      <Footer data-id="element-169" />
    </div>;
}